import { IconMap } from '../../../../shared/sprite';
import { Icon } from '../../../../shared/ui';
import { FC } from 'react';
import { VideoRecordType } from '@distribute/shared/api-types/video-record';
import { useSelector } from 'react-redux';
import { authUserModel } from '../../../../entities/auth-user';
import { useRecordPermissions } from '../../../recordings/hooks';

type Props = {
  isSharedWithTeam: boolean;
  membersCount: number;
};

type SharedRecordProps = {
  record: VideoRecordType;
};

export const RecordMemberStatus: FC<Props> = ({
  isSharedWithTeam,
  membersCount,
}) => {
  if (isSharedWithTeam) {
    return (
      <div className="flex flex-nowrap gap-x-1 items-center">
        <Icon glyph={IconMap.Users01} width={16} />
        <p>Team access</p>
      </div>
    );
  }

  if (membersCount <= 1) {
    return (
      <div className="flex flex-nowrap gap-x-1 items-center">
        <Icon glyph={IconMap.Lock} width={16} />
        <p>Private</p>
      </div>
    );
  }

  return (
    <div className="flex flex-nowrap gap-x-1 items-center">
      <Icon glyph={IconMap.Users01} width={16} />
      <p>{`${membersCount} members`}</p>
    </div>
  );
};

export const SharedMemberStatus: FC<SharedRecordProps> = ({ record }) => {
  const { teamMembersPermission, userPermissionToVideoRecords } = record;

  const user = useSelector(authUserModel.selectors.selectUserWithError);

  const permissions = useRecordPermissions({
    userId: user.id,
    userPermissionToVideoRecords,
    teamMembersPermission,
  });

  return <p>{permissions.isCanEdit ? 'Can Edit' : 'Can View'}</p>;
};
